import React from "react";
import { TimePicker } from "@mui/x-date-pickers";
import { datePickerSx } from "lib/muiStyle/muiStyle";
import Label from "../Label/Label";
import HelperMessage from "components/Input/HelperMessage/HelperMessage";
import c from "lib/style/colorVar.scss";
import dayjs from "dayjs";

const Timepicker = ({
  inputRef,
  label,
  subLabel,
  hideLabel = false,
  emptyLabel = false,
  mandatory,
  type,
  errorMessage,
  noErrorMessage,
  onchangeFn,
  onfocusFn,
  onblurFn,
  value,
  defaultValue,
  sxParams,
  disabled,
  readOnly,
  divStyle,
}) => {
  const { datepickerFocus, datepickerError } = sxParams;
  return (
    <div onFocus={onfocusFn} onBlur={onblurFn} style={divStyle}>
      {!hideLabel && <Label label={label} subLabel={subLabel} mandatory={mandatory} empty={emptyLabel} />}
      <TimePicker
        inputRef={inputRef}
        slotProps={{
          textField: {
            size: "small",
            style: disabled ? { background: c.disabledFieldBg } : {},
          },
        }}
        value={value && dayjs(value)}
        defaultValue={defaultValue && dayjs(defaultValue)}
        onChange={(e) => onchangeFn(e, type)}
        views={["hours", "minutes", "seconds"]}
        ampm={false}
        timeSteps={{ minutes: 1, seconds: 1 }}
        sx={() => datePickerSx(datepickerFocus, datepickerError)}
        disabled={disabled}
        readOnly={readOnly}
      />
      {!noErrorMessage && (
        <HelperMessage message={datepickerError && errorMessage} />
      )}
    </div>
  );
};

export default React.memo(Timepicker);
